import {
    mdiArrowCollapseAll,
    mdiArrowExpandAll,
    mdiClose,
    mdiContentSave,
    mdiDotsHorizontal,
    mdiPencil,
} from '@mdi/js';
import DocTableMenu from '../DocTable/DocTableMenu';
import { IDocumentDetailsControlsProps } from './DocDetailsControls';
import React from 'react';

/**
 * Config for the Controls Component for the Document details.
 */
export default ({
    docType,
    docTypeKey,
    universalId,
    isExpanded,
    handleChangeMode,
    handleExpandDialog,
    handleCloseDialog,
    handleClickSaveBtn,
    isDialog,
    isSaveButtonDisabled,
    isSaveButtonLoaded,
    isEditButtonDisabled,
}: IDocumentDetailsControlsProps) => ({
    ...(!docTypeKey && {
        editDocument: {
            icon: mdiPencil,
            onClick: () => handleChangeMode(),
            disabled: isEditButtonDisabled,
        },
    }),
    saveDocument: {
        icon: mdiContentSave,
        onClick: () => handleClickSaveBtn(),
        disabled: isSaveButtonDisabled,
        loading: isSaveButtonLoaded,
    },
    ...(!docTypeKey && {
        openContextMenu: {
            component: (
                <DocTableMenu
                    docType={docType}
                    universalId={universalId}
                    icon={mdiDotsHorizontal}
                    exclude={['showDetails']}
                    key='openContextMenu'
                />
            ),
        },
    }),
    ...(isDialog && {
        expandDialog: {
            icon: isExpanded ? mdiArrowCollapseAll : mdiArrowExpandAll,
            onClick: () => handleExpandDialog(),
        },
        closeDialog: {
            icon: mdiClose,
            onClick: () => handleCloseDialog(),
        },
    }),
});
